type BuildVersionProps = {
  buildVersion: {
    lowerBuildNumber?: number;
    higherBuildNumber?: number;
  };
  /** 동시에 appVersion을 넘기면 컴파일 오류 */
  appVersion?: never;
};

type AppVersionProps = {
  appVersion: {
    lowerBuildVersion?: {
      major: number;
      minor: number;
      patch: number;
    };
    higherBuildVersion?: {
      major: number;
      minor: number;
      patch: number;
    };
  };
  buildVersion?: never;
};

type Props = BuildVersionProps | AppVersionProps;
export function compareVersion(obj: Props): boolean {
  if ('buildVersion' in obj && obj.buildVersion) {
    const {buildVersion} = obj;
    if (
      buildVersion.lowerBuildNumber !== undefined &&
      buildVersion.higherBuildNumber !== undefined
    ) {
      return buildVersion.lowerBuildNumber < buildVersion.higherBuildNumber;
    }
  }
  if ('appVersion' in obj && obj.appVersion) {
    const {appVersion} = obj;
    if (
      appVersion.lowerBuildVersion !== undefined &&
      appVersion.higherBuildVersion !== undefined
    ) {
      return (
        appVersion.lowerBuildVersion.major <
          appVersion.higherBuildVersion.major ||
        (appVersion.lowerBuildVersion.major ===
          appVersion.higherBuildVersion.major &&
          appVersion.lowerBuildVersion.minor <
            appVersion.higherBuildVersion.minor) ||
        (appVersion.lowerBuildVersion.major ===
          appVersion.higherBuildVersion.major &&
          appVersion.lowerBuildVersion.minor ===
            appVersion.higherBuildVersion.minor &&
          appVersion.lowerBuildVersion.patch <
            appVersion.higherBuildVersion.patch)
      );
    }
  }
  return false;
}
